module.exports = __webpack_public_path__ + "static/media/close-maincolor.fd3f77e4.svg";